const route = {
	path: 'costs-centers',
	name: 'costs-centers',
	meta: {
		title: 'Centros de Costos',
	},
	component: () => import('@/pages/cost-centers/page-cost-center'),
	props: true,
	children: [
		{
			path: 'new',
			name: 'cost-center-new',
			meta: {
				title: 'Nueva Centro de Costos',
			},
			component: () => import('@/pages/cost-centers/page-cost-center-new'),
			props: true,
		},
		{
			path: ':id/:fatherId/edit',
			name: 'cost-center-edit',
			meta: {
				title: 'Editar Centro de Costos',
			},
			component: () => import('@/pages/cost-centers/page-cost-center-new'),
			props: true,
		},
		{
			path: 'import',
			name: 'cost-center-import',
			meta: {
				title: 'Importar Centro de Costos',
			},
			component: () => import('@/pages/cost-centers/page-cost-center-import'),
			props: true,
		},
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/cost-centers.js